// 审批表头数据
export const ExamineHeadsModel = [{
  name: '审批内容',
  field: 'content',
  width: 120,
  formType: 'text'
}, {
  name: '创建人',
  field: 'createUser',
  width: 120,
  formType: 'user'
}, {
  name: '审批类型',
  field: 'categoryTitle',
  width: 80
}, {
  name: '状态',
  field: 'examineStatus',
  width: 80,
  formType: 'examineStatus'
}, {
  name: '创建日期 ',
  field: 'createTime',
  width: 80
}]
